import CreateOrUpdateCustomer, { CreateOrUpdateCustomerRef } from 'features/customer/pages/ListCustomerPage/components/DetailsCustomerModal/components/CreateOrUpdateCustomer';
import React from 'react';
export const customerEditorRef = React.createRef<CreateOrUpdateCustomerRef>();
const CustomerEditor = () => {
  const handleCreateCustomerSuccess = () => undefined;
  return (
    <>
      <CreateOrUpdateCustomer
        ref={customerEditorRef}
        onSuccess={handleCreateCustomerSuccess}
      />
    </>
  );
};

export default CustomerEditor;
